import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { PropTypes as PT } from 'prop-types';
import ReactSpinner from 'react16-spinjs';
import Button from 'components/Button/Button';
import classes from './OneTimeMeetingButtons.module.scss';

export const OneTimeMeetingButtons = props =>
  (
    <div className={classes.buttonBar}>
      {props.children}
      <Button
        onClick={() => {
          props.onBackClicked();
        }}
        style={{ minWidth: 151, padding: 0, width: 206, height: 50, lineHeight: '50px' }}
        kind="secondary"
        dataAttrs={{ 'data-testid': 'one-time-meet-back' }}
      >
        <FormattedMessage
          id="components.schedule.oneTime.back"
          defaultMessage="Back"
        />
      </Button>
      <Button
        type="submit"
        disabled={props.pristine || !props.valid || props.savingContact || !!props.contactFormError}
        style={{ minWidth: 151, padding: 0, width: 206, height: 50, lineHeight: '50px' }}
        dataAttrs={{ 'data-testid': 'one-time-meet-next' }}
      >
        {props.savingContact ?
          <ReactSpinner
            config={{
              lines: 13,
              length: 5,
              width: 3,
              radius: 5,
              color: '#fff',
              speed: 0.7
            }}
          />
          :
          <FormattedMessage
            id="components.schedule.oneTime.next"
            defaultMessage="Next"
          />
        }
      </Button>
    </div >
  );

OneTimeMeetingButtons.propTypes = {
  onBackClicked: PT.func,
  pristine: PT.bool,
  valid: PT.bool,
  savingContact: PT.bool,
  children: PT.element,
  contactFormError: PT.string
};

export default injectIntl(OneTimeMeetingButtons);
